import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/DocsPage.svg?component
var DocsPage_exports = /* @__PURE__ */ __exportAll({
	default: () => DocsPage_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M5.4 22.2h13c1.1 0 2-.9 2-2V3.6c0-1.1-.9-2-2-2h-9l-6 6v12.6c0 1.1.9 2 2 2"
	}, null, -1), createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M3.6 7.6h4c1.1 0 2-.9 2-2v-4zm9.4 0h4m-10 5h10M7 17.4h10"
	}, null, -1)])]);
}
var DocsPage_default = { render: render$1 };
//#endregion
export { DocsPage_exports, DocsPage_default as default, render$1 as render };

//# sourceMappingURL=DocsPage.svg.virtual.js.map